const ORDER_ACTION_TYPES = {
  LOAD_ORDER: 'order/LOAD_ORDER',
};

export default ORDER_ACTION_TYPES;
